import Vue from 'vue'
import Router from 'vue-router'

import { cachePreviousPath, checkNativeOnlyMiddleware, checkAccessMiddleware, setPageTitleMiddleware, resetChatbox } from './middlewares'
import { routes } from './routes'
import { isHashOnlyChange } from './util'


// Patches push/replace pra silenciar "NavigationFailure" (NavigationCancelled,
// NavigationDuplicated, etc) que Vue Router 3 lança como Promise rejection.
// Sem o catch, o .finally() do replace ainda roda, mas a Promise rejected vira
// "Uncaught (in promise)" no console — ruído e potencial quebra de chains.
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // Deep link de comentário na aula já aberta: a aula rola até a resposta e
    // limpa o hash com replace — voltar ao topo aqui desfazia a rolagem.
    if (isHashOnlyChange(to, from)) return;
    if(to.name === 'course' || to.name == 'class' || to.name == 'my-courses' || to.name === 'trustflix') {
      return { x:0, y:0 };
    }
  }
})

router.beforeEach(cachePreviousPath)
router.beforeEach(checkNativeOnlyMiddleware)
router.beforeEach(checkAccessMiddleware)
router.beforeEach(setPageTitleMiddleware)
router.beforeEach(resetChatbox)

export default router
